// extracted by mini-css-extract-plugin
export default {"advice-icon":"_5DTDWjJJ","relationship":"_5D1-LEUJ","friend-family":"_5D3eCveP","dating":"_5D2YyXK-","significant-other":"_5DnhQY0J"};